import { Link } from "react-router-dom";

export function BrandMark({ to = "/" }: { to?: string }) {
  return (
    <Link to={to} className="flex items-center gap-2.5">
      <span
        aria-hidden
        className="grid h-7 w-7 place-items-center rounded-[8px] bg-[var(--color-brand)] text-white"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="2.5" y="3" width="11" height="10" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
          <circle cx="5.6" cy="8" r="0.9" fill="currentColor" />
          <circle cx="10.4" cy="8" r="0.9" fill="currentColor" />
        </svg>
      </span>
      <span className="text-[15px] font-semibold tracking-[-0.005em] text-[var(--color-fg)]">
        АстраМаркет
      </span>
    </Link>
  );
}
